document.addEventListener("DOMContentLoaded", () => {
    const addToCart = document.querySelector(".dynamicAbButton");
    const inputs = Array.from(document.querySelectorAll(".product-variant-card__item input"));
    const priceBox = document.querySelector(".gppCustom");
    const varTitle = document.querySelector(".gppVariantTitle");
    const bestTitle = document.querySelector(".gppValueTitle");

    function updatePrice(price, compare, currency, savings, variant, best, id) {
        let html = `<span class="price">${price}</span>`;
        if (compare && compare !== "" && compare !== price) {
            html += `<span class="compare">${compare} ${currency}</span>`;
        }
        if (savings && savings !== "") {
            html += `<span class="gridPriceSavingsCtn"><span class="gridPriceSavings">${savings}</span></span>`;
        }
        
        if (varTitle) varTitle.innerHTML = variant;
        if (bestTitle) bestTitle.innerHTML = best;
        if (priceBox) priceBox.innerHTML = html;

        addToCart.setAttribute("data-current-id", id);
        addToCart.removeAttribute("href");
        addToCart.style.cursor = "pointer";
    }

    addToCart.addEventListener("click", async (e) => {
        e.preventDefault(); 
        
        let variantId = addToCart.getAttribute("data-current-id");
        
       
        if (!variantId) {
            const href = addToCart.getAttribute("href");
            if (href) {
                const match = href.match(/\/cart\/(\d+)/);
                if (match && match[1]) {
                    variantId = match[1];
                    
                    addToCart.setAttribute("data-current-id", variantId);
                    addToCart.removeAttribute("href");
                    addToCart.style.cursor = "pointer";
                }
            }
        }

        if (!variantId) {
            alert("Please select a variant");
            return;
        }

        const originalText = addToCart.innerHTML;
        addToCart.innerHTML = "Adding...";
        addToCart.style.pointerEvents = "none";

        try {
            const isFirstAddition = !sessionStorage.getItem('cart_cleared_once');

            if (isFirstAddition) {
                await fetch('/cart/clear.js', { method: 'POST' });
                sessionStorage.setItem('cart_cleared_once', 'true');
                console.log("Cart cleared for the first time in this session.");
            }

       
            if (window.ShopifyCartCache) {
                window.ShopifyCartCache.data = null;
                window.ShopifyCartCache.timestamp = 0;
            }

          
            if (window.addToCartExternally) {
                await window.addToCartExternally(variantId, 1);
                
                addToCart.innerHTML = "Added!";
                setTimeout(() => {
                    addToCart.innerHTML = originalText;
                    addToCart.style.pointerEvents = "all";
                }, 2000);
                
            } else {
                // Fallback
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        items: [{ id: variantId, quantity: 1 }]
                    })
                });

                if (response.ok) {
                    const cartResponse = await fetch('/cart.js');
                    const cartData = await cartResponse.json();

                    addToCart.innerHTML = "Added!";
                    setTimeout(() => {
                        addToCart.innerHTML = originalText;
                        addToCart.style.pointerEvents = "all";
                    }, 2000);
                    
                    const cartIcon = document.querySelector('#OpenCartDrawer');
                    if (cartIcon) {
                        cartIcon.click(); 
                    }

                    const updateEvent = new CustomEvent('cart:updated', { 
                        bubbles: true,
                        detail: { 
                            cart: cartData 
                        }
                    });
                    
                    Object.assign(updateEvent.detail, cartData); 
                    document.dispatchEvent(updateEvent);

                    console.log("Cart event dispatched with data:", cartData);
                }
            }
        } catch (error) {
            console.error("Error adding to cart:", error);
            addToCart.innerHTML = "Error";
            addToCart.style.pointerEvents = "all";
        }
    });

    inputs.forEach(input => {
        input.addEventListener("change", () => {
            if (input.checked) {
                const price = input.parentElement.getAttribute('data-variant-price');
                const compare = input.dataset.compare;
                const savings = input.dataset.savings || "";
                const c = input.dataset.currency;
                const variantTitle = input.dataset.variant || "";
                const best = input.dataset.best || "";
                const variantId = input.dataset.vid;
                
                updatePrice(price, compare, c, savings, variantTitle, best, variantId);
            }
        });
    });
    
});
